import type { ClientWithServices } from '../dto/client-with-services';
import type { GetAllClientsByUserIdUseCase } from './get-all-clients-by-user-id';
import type { GetAllServicesUseCase } from '@/features/app/services/domain/usecases/get-all-services';

/**
 * Obtém clientes do usuário com serviços realizados e próxima manutenção.
 * Agrega serviços por client_id e define nextMaintenanceDate a partir do serviço mais recente.
 */
export class GetClientsWithServicesByUserIdUseCase {
  constructor(
    private readonly getAllClientsByUserIdUseCase: GetAllClientsByUserIdUseCase,
    private readonly getAllServicesUseCase: GetAllServicesUseCase
  ) {}

  async execute(userId: string): Promise<ClientWithServices[]> {
    const [clients, services] = await Promise.all([
      this.getAllClientsByUserIdUseCase.execute(userId),
      this.getAllServicesUseCase.execute(userId),
    ]);

    return clients.map((client) => {
      const clientServices = services
        .filter((s) => s.client_id === client.id)
        .sort((a, b) => b.service_date.localeCompare(a.service_date));
      const nextMaintenanceDate =
        clientServices.length > 0 ? clientServices[0].next_maintenance_date : null;

      return {
        client,
        services: clientServices,
        nextMaintenanceDate,
      } satisfies ClientWithServices;
    });
  }
}
